import React, { useState, useEffect } from 'react';

import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import Card from '../Card';
import SemDados from '../SemDados';
import * as S from './styles';

function CardVazoesNaoAutorizadas({ data, style }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => (prevPage < totalPages ? prevPage + 1 : 1));
  };

  /* const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  }; */

  useEffect(() => {
    setCurrentPage(1); // reset ao mudar os dados
  }, [data]);

  useEffect(() => {
    if (totalPages > 1) {
      const timer = setInterval(() => {
        setCurrentPage((prevPage) =>
          prevPage < totalPages ? prevPage + 1 : 1
        );
      }, 10000);

      return () => clearInterval(timer);
    }
  }, [totalPages]);

  return (
    <Card
      title={t('s.dashboard.visaogeral.vazoesnaoautorizadas')}
      icon={<Close />}
      paginacao={totalPages > 1 ? `${currentPage}/${totalPages}` : ''}
      tooltip={t('s.dashboard.visaogeral.tooltip.vazaonaoautorizada')}
      style={style}
    >
      {data && data.length > 0 ? (
        <S.Container style={{ '--total-table-rows': currentItems.length + 1 }}>
          <TableContainer>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell key="cell-index-head-1">
                    {t('s.menu.configuracao.produto')}
                  </TableCell>
                  <TableCell key="cell-index-head-2">
                    {t('s.geral.volvazao')}
                  </TableCell>
                  <TableCell key="cell-index-head-3">
                    {t('s.configuracao.dashboard.volumemovimentacao')}
                  </TableCell>
                  <TableCell key="cell-index-head-4">%</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentItems.map((row, index) => (
                  <TableRow tabIndex={-1} key={`table-row-body-${index}`}>
                    <TableCell key="table-cell-body-1">
                      {row.nomeabreviadoproduto}
                    </TableCell>
                    <TableCell key="table-cell-body-2">
                      {`${number(row.volumevazaonaoautorizada, 2)}L`}
                    </TableCell>
                    <TableCell key="table-cell-body-3">
                      {`${number(row.volumemovimentacaoperiodo, 2)}L`}
                    </TableCell>
                    <TableCell key="table-cell-body-4">
                      {`${number(row.percentualvazaonaoautorizada, 2)}%`}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </S.Container>
      ) : (
        <SemDados />
      )}
    </Card>
  );
}

CardVazoesNaoAutorizadas.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      nomeabreviadoproduto: PropTypes.string.isRequired,
      volumevazaonaoautorizada: PropTypes.number.isRequired,
      volumemovimentacaoperiodo: PropTypes.number.isRequired,
      percentualvazaonaoautorizada: PropTypes.number.isRequired,
    })
  ).isRequired,
  style: PropTypes.objectOf(PropTypes.any),
};

CardVazoesNaoAutorizadas.defaultProps = {
  style: {},
};

export default CardVazoesNaoAutorizadas;
